import { vars } from "@common/styles";
import styled from "styled-components";

/* No margin-left: the DetailsTitle inside already carries the same 0.8rem padding-left the open
   ticket's title uses, so the spacing matches a ticket with no parent. */
export const Crumb = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  gap: 0.8rem;

  svg {
    flex-shrink: 0;
  }
`;

export const Separator = styled.span`
  color: ${vars.colors.grey60};
`;
